<section class="mb-18 pt-2 pt-xl-2">
  <div class="row justify-content-center" style="margin-top: 48px">
    <div class="col-md-9 justify-content-center" style="text-align: center">
      <h1
        class="outage-heading"
        [innerHTML]="
          'RS.INTERNAL_SERVICE_OUTAGE.HEADING' | translate | safeHtml
        "
      ></h1>

      <div class="col-md-9 center-margins" style="margin-bottom: 52px">
        <img alt="disconnected cloud image" src="/assets/cloud-off.svg" />
      </div>

      <div class="col-md-9 text-center text-color-primary-dark center-margins">
        <h3
          class="outage-subtext"
          [innerHTML]="
            'RS.INTERNAL_SERVICE_OUTAGE.MESSAGE_ONE' | translate | safeHtml
          "
        ></h3>
        <h3
          class="outage-subtext"
          [innerHTML]="
            'RS.INTERNAL_SERVICE_OUTAGE.MESSAGE_TWO' | translate | safeHtml
          "
        ></h3>
      </div>
    </div>
  </div>
</section>
